import HttpBackend from "i18next-http-backend";
import { StarlingClientBackend } from "./backends/starling-api.browser";
import { I18n } from "./core";
export * from "./exports";
export * from "./react";
const i18n = I18n._create(typeof __I18N_USE_API__ !== "undefined" && __I18N_USE_API__ ? StarlingClientBackend : HttpBackend);
const initI18n = function(lng, initOptions = {}, i18nextPlugins = []) {
  return i18n.init(lng, initOptions, i18nextPlugins).then(() => i18n);
};
export {
  i18n,
  initI18n
};

//# sourceMappingURL=browser.js.map